export default "__VITE_ASSET__C5Ee09ll__";